// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var OptionUtils$SmartcutsMacros = require("../../packages/bs-utils/src/OptionUtils.bs.js");
var ManifestJson = require("../../packages/bs-macros-extension/manifest.json");

var arg = process.env.VERCEL_GITLAB_COMMIT_SHA;

var arg$1 = (function (param) {
      return OptionUtils$SmartcutsMacros.orElse(param, arg);
    })(process.env.NEXT_PUBLIC_GIT_SHA);

var webappVersion = (function (param) {
      return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    })("Expected an appVersion to be set");

var manifest = ManifestJson;

var lastPublishedExtensionVersion = manifest.version;

var publicUserToken = process.env.FAUNA_DB_PUBLIC_USER_SECRET;

var extensionId = "pbdjbjpckecmjacpfkjnmahlfjjhjofp";

exports.webappVersion = webappVersion;
exports.manifest = manifest;
exports.lastPublishedExtensionVersion = lastPublishedExtensionVersion;
exports.publicUserToken = publicUserToken;
exports.extensionId = extensionId;
/* arg Not a pure module */
